import React from "react";
import { withERPSBaseDiv } from "../../hoc/withERPSBaseDiv";
import { ResponsiveBox } from "../../primitives";

function ERPSBaseBox(props) {
  const { children, ...rest } = props;
  return <ResponsiveBox {...rest}>{children}</ResponsiveBox>;
}

export default withERPSBaseDiv(ERPSBaseBox);
